export enum PostQualificationLanguage {
    English = "English",
    German = "German"
}
